export enum Group {
  GLOBAL_ADMIN = 'Global Admin',
  PHYSICIAN = 'Physician',
  OWNER = 'Owner',
  MEDICAL_DIRECTOR = 'Medical Director',
  CLINIC_ADMINISTRATOR = 'Clinic Administrator',
  ACCREDITATION_SPECIALIST = 'QUADA - Accreditation Specialist',
  ADMIN_LITE = 'Admin Lite',
  ACCREDITATION_DIRECTOR = 'QUADA - Accreditation Director',
  FINANCE_SPECIALIST = 'QUADA - Finance Specialist',
  SCHEDULING_TEAM = 'QUADA - Scheduling Team'
}
